var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.62097 0.378346L15.8299 12.8649C15.8963 12.9799 15.9312 13.1104 15.9312 13.2432C15.9312 13.3761 15.8963 13.5066 15.8299 13.6216C15.7634 13.7367 15.6679 13.8322 15.5529 13.8986C15.4378 13.965 15.3073 14 15.1745 14H0.756739C0.623902 14 0.493406 13.965 0.378367 13.8986C0.263328 13.8322 0.167799 13.7367 0.101382 13.6216C0.0349644 13.5066 -8.43658e-07 13.3761 0 13.2432C8.43688e-07 13.1104 0.0349679 12.9799 0.101386 12.8649L7.31027 0.378346C7.37669 0.263313 7.47222 0.16779 7.58726 0.101377C7.7023 0.0349634 7.83279 0 7.96562 0C8.09845 0 8.22895 0.0349634 8.34398 0.101377C8.45902 0.16779 8.55455 0.263313 8.62097 0.378346ZM2.06745 12.4865H13.8638L7.96562 2.27024L2.06745 12.4865ZM7.20886 10.2162H8.72238V11.7297H7.20886V10.2162ZM7.20886 4.9189H8.72238V8.70269H7.20886V4.9189Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/Alerts.7c4e2ff84da674fa0455c779f7faea58.svg";
export { ForwardRef as ReactComponent };